import { RefObject, useCallback, useEffect, useState } from 'react';

/**
 * TEMPORARY WORKAROUND: Custom hook to check if content is empty using MutationObserver
 *
 * TODO: ED-1135. Refactor content detection to work with TipTap content objects directly
 * instead of relying on DOM mutations after rendering.
 *
 */
export const useContentEmptyCheck = (contentRef: RefObject<HTMLDivElement | null>) => {
  const [isContentEmpty, setIsContentEmpty] = useState(true);

  const checkIfContentIsEmpty = useCallback(() => {
    const textContent = contentRef.current?.textContent?.trim() || '';
    setIsContentEmpty(textContent === '');
  }, [contentRef]);

  useEffect(() => {
    checkIfContentIsEmpty();
    const observer = new MutationObserver(() => {
      checkIfContentIsEmpty();
    });

    if (contentRef.current) {
      observer.observe(contentRef.current, { childList: true, subtree: true, characterData: true });
    }

    return () => {
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentRef]);

  return { isContentEmpty };
};
